import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, OnDestroy, ViewChild } from '@angular/core';
import { DatePipe,JsonPipe,LowerCasePipe,UpperCasePipe, TitleCasePipe, CommonModule  } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import * as Timecombo from 'app/Shared/Constant/TimeDropDown.json';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { GridService } from 'app/Shared/Services/grid.service';
import { UserService } from 'app/Shared/Services/user.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { ConstantService } from 'app/Shared/Services/constant-service';
import {MatTooltipModule} from '@angular/material/tooltip';
import { ButtonModule } from 'primeng/button';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { DialogModule } from 'primeng/dialog';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatChipsModule} from '@angular/material/chips';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast';
import { MatDividerModule } from '@angular/material/divider';
import { DatepickerService } from '../datepicker-calendar/datepicker.service';
import { DatepickerCalendarComponent } from '../datepicker-calendar/datepicker-calendar.component';
import { Select } from 'primeng/select';
import { CompReviewServiceService } from 'app/Pages/cat-dashboard/comparative-review/comp-review-service.service';
import { DatePicker } from 'primeng/datepicker';
import { FinraInquiryServiceService } from 'app/Pages/reg-inquiry/finra-inquiry/finra-inquiry-service.service';
@Component({
    selector: 'app-filter-panel',
    imports: [MatTooltipModule, Select, ButtonModule, MultiSelectModule, MatChipsModule,
        MatIconModule, CommonModule, FormsModule,
        TitleCasePipe, LowerCasePipe, UpperCasePipe, MatDatepickerModule, MatNativeDateModule, ReactiveFormsModule,
        DialogModule, MatFormFieldModule, MatAutocompleteModule, JsonPipe, CheckboxModule, ToastModule, MatDividerModule,
        DatepickerCalendarComponent
    ],
    providers: [],
    templateUrl: './filter-panel.component.html',
    styleUrls: ['./filter-panel.component.scss']
})

export class FilterPanelComponent implements OnInit, OnChanges, OnDestroy {
  @Input('DefaultFilterArray') DefaultFilterArray: any;
  @Input('GridColumns') GridColumns: any;
  @Input('ResetLabel') ResetLabel: any;
  @Input('isAddFilter') isAddFilter: boolean = true;
  @Input('isDatefilterDropdown') isDatefilterDropdown: boolean = false;
  @Input('pageName') pageName!: string;
  @Input('ActiveApplicationFilter') ActiveApplicationFilter: any = new Object();
  @Input('isOpenFilterDialog') isOpenFilterDialog: boolean = false;
  @Output() FilterEvent: EventEmitter<any> = new EventEmitter();
  @Output() FilterEventClearSymbol: EventEmitter<any> = new EventEmitter();
  @Output() FilterEventClearCode: EventEmitter<any> = new EventEmitter();
  @Output() FilterEventClearEventType: EventEmitter<any> = new EventEmitter();
  @Output() FilterEventClearGroupName: EventEmitter<any> = new EventEmitter();
  @Output() FilterEventClearSampleName: EventEmitter<any> = new EventEmitter();
  @Output() FilterEventCompReportReload: EventEmitter<any> = new EventEmitter();
  @Output() RetrieveApplicationFilters: EventEmitter<any> = new EventEmitter();
  @Output() clearApplicationFilter: EventEmitter<any> = new EventEmitter();
  @Output() FilterEventClearRepresentativeOrder: EventEmitter<any> = new EventEmitter();
  @ViewChild('myCalendar') datePicker!: DatePicker;
  @Output() FetchUpdatedDefaultFilters: EventEmitter<any> = new EventEmitter();
  
  maxdate = new Date();
  todate: any;
  hoveredIndex: any;
  displayFilter!: boolean;
  showMessage:boolean=false;
  showMessageDetails="";
  public FilterData: any = [];
  public TempFilterData: any[] = [];
  public ApliedFilterName: any = [];
  filterByString!: { label: string; value: string; }[];
  filterByInt!: { label: string; value: string; }[];
  filterByBoolean!:{ label: string; value: string; }[];
  filterCols: any = [];
  public DefaultFixedFilterArray: any = [];
  TimeDropDown: any;
  subscription: Subscription;
  public FilterAccessibleApplications: any = [];
  public isSaveFilter: any = false;
  public savedFilterQuaryName: string = '';
  rowCount:any;
  filterHeader="Filter Columns";
  isAddSamples:boolean = false;
  updatedUser : any = "";
  updatedDate : any = "";
  isAddInquiry:boolean = false;
  displayUserInfo : boolean = false;

  constructor(private datePipe: DatePipe,
    private emitterService: EmitterService,
    private gridService: GridService,
    private sharedHttpClientService: SharedHttpClientService,
    public urlService: UrlsService,
    private messageService: MessageService,
    private ConstantService: ConstantService,
    public userService: UserService,
    private datepickerService: DatepickerService,
    public compReviewServiceService:CompReviewServiceService,
    public FinraInquiryServiceService:FinraInquiryServiceService,
    private confirmationService:ConfirmationService ) {
    this.subscription = this.emitterService.ReloadQuickFilterPanelEvent.subscribe(event => {
      if (event) {
        this.resetFilter()
      }
    });
    this.subscription = this.emitterService.ActiveCustomSampleFilterQuery.subscribe(event => {
      if (event) {
        this.compReviewServiceService.optedApplicationFilter = event;
        let DateFilterObj = this.compReviewServiceService.SampleFilterArray.filter((res: any) => res.label === 'Sample Date *');
        let optedFilterData = [...DateFilterObj, ...JSON.parse(event.filter_queries)];
        this.updatedDate = event.created_date;
        this.updatedUser = event.created_by;
        this.displayUserInfo=true;
        this.compReviewServiceService.SampleFilterArray = optedFilterData;
        this.addSamples();
        
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes != undefined && changes['ActiveApplicationFilter']!= undefined && changes['ActiveApplicationFilter'] != null && Object.keys(changes['ActiveApplicationFilter']).length > 0
    && this.ActiveApplicationFilter != undefined && this.ActiveApplicationFilter.filter_query_name != undefined) {
      this.isSaveFilter = false;
      this.savedFilterQuaryName = this.ActiveApplicationFilter.filter_query_name.trim();
      this.filterLabels();
    } else if(changes != undefined && changes['ActiveApplicationFilter']!= undefined && changes['ActiveApplicationFilter'] != null && changes['ActiveApplicationFilter'] && (Object.keys(changes['ActiveApplicationFilter']).length === 0 || Object.keys(changes['ActiveApplicationFilter']['currentValue']).length === 0)) {
      this.isSaveFilter = false;
      this.savedFilterQuaryName = '';
      this.filterLabels();
    }

    /* Receiving of GridColumns changes */
    if (changes['GridColumns'] && changes['GridColumns'].currentValue) {
      this.setFilterDropdown();
    } /* End Receiving of GridColumns changes */

    if (changes['DefaultFilterArray'] && changes['DefaultFilterArray'].currentValue) {
      this.TempFilterData = [];
      this.TempFilterData = changes['DefaultFilterArray'].currentValue;
      /* Reset and update Fixed Filter Array with Existing Default Filters */
        this.DefaultFixedFilterArray = [];
        for (let i = 0; i < changes['DefaultFilterArray'].currentValue.length; i++) {
          this.DefaultFixedFilterArray.push(changes['DefaultFilterArray'].currentValue[i]);
        }
      /* End of update Fixed Filter Array with Existing Default Filters */
      this.filterLabels();

      /* Open Filter Dialogbox when needed by Parent Component */
        if(changes['isOpenFilterDialog'] && changes['isOpenFilterDialog'].currentValue===true) {
          if(["Reg-Inquiry-List"].includes(this.pageName)) {
            this.filterHeader = "Edit Inquiry";
            this.isAddInquiry = true;
            this.displayFilter = true;
          }
        }
      /* End of Opening Filter Dialogbox when needed by Parent Component */
    }

    for (let i = 0; i < this.TempFilterData.length; i++) {
      this.changeFilterDataType(this.TempFilterData[i]);
    }

  }

  resetSampleDefault(){
    this.compReviewServiceService.customSampleName='';
    this.compReviewServiceService.sampleFilter();
    this.displayUserInfo=false;
    this.addSamples();
  }

  addSamples(){
    this.filterHeader="Add Custom Samples";
    this.isAddSamples=true;
    this.displayFilter=true;
    let reportDate =this.userService.getFormatedDate(this.TempFilterData[0].values[0]);
    this.compReviewServiceService.LastExecutionCompDate=[reportDate,reportDate];
    this.compReviewServiceService.SampleFilterArray[0]["values"]=[reportDate,reportDate];
    this.compReviewServiceService.SampleFilterArray[0]["dateFilterValue"]=reportDate;
    if (this.compReviewServiceService.SampleFilterArray) {
      this.TempFilterData = [];
      this.DefaultFixedFilterArray[0]["values"] = this.compReviewServiceService.LastExecutionCompDate;
      for (const element of this.compReviewServiceService.SampleFilterArray)
        this.TempFilterData.push(element);
    }
    let sampleIndex = this.TempFilterData.findIndex((filterElem: { columnname: string; }) => filterElem.columnname === 'sampleName');
    this.compReviewServiceService.customSampleName=this.TempFilterData[sampleIndex]["values"];
    if(!this.displayUserInfo){
      this.updatedDate="";
      this.updatedUser="";
    }
   
  }

  resetSample(){
    if (this.compReviewServiceService.SampleFilterArray) {
      for (const element of this.compReviewServiceService.SampleFilterArray){
      if (!"Date,reportDate,Type".includes(element['columnname'])) {
            this.compReviewServiceService.customSampleName = "";
            element['values']="";
          }
        }
    }
  }

  /* Open Add Inquiry Popup */
    addInquiryDialog() {
      this.FetchUpdatedDefaultFilters.emit('Add-Inquiry-Dialog');
      this.filterHeader = "Add Inquiry";
      this.isAddInquiry = true;
      this.displayFilter = true;
    }
  /* End of Opening Add Inquiry Popup */

  resetDefaultFilter() {
    if (this.DefaultFixedFilterArray) {
      this.TempFilterData = [];
      this.DefaultFixedFilterArray[0]["values"] = this.compReviewServiceService.LastExecutionCompDate;
      for (const element of this.DefaultFixedFilterArray)
        this.TempFilterData.push(element);
    }
  }

  closeFilterDialog(){
    this.isOpenFilterDialog = false;
    this.displayUserInfo=false;
    this.filterHeader = "Filter Columns";
    this.displayFilter = false;
    this.isAddSamples=false;
    this.isAddInquiry = false;
    this.isSaveFilter=false;
    this.savedFilterQuaryName ="";
    if (this.pageName == "Comparative-Review-Report") {
      this.resetDefaultFilter();
    } else if(["Reg-Inquiry-List"].includes(this.pageName)) {
      this.FetchUpdatedDefaultFilters.emit("Default-Filter-Dialog"); // Preserve Default Filter with its original Field List
    }
  }

  onKeyPress(key:any,value:any,index:any){
    if(this.isAddSamples && key){
      if(key.toLocaleLowerCase()  === 'samplename' || key.toLocaleLowerCase()  === 'sample name'){
        this.compReviewServiceService.customSampleName = value;
      }
  
    if((key.toLocaleLowerCase()  === 'samplecount' 
    || key.toLocaleLowerCase()  === 'sample count') && value>50){
      this.messageService.add({ severity: 'warn', summary: 'Sample Generation', detail: "Max sample count allowed 50" });
      this.TempFilterData[index]["values"] = 50; 
    }
  }
  }

  runComparativeReport(){
          this.userService.logUserActivity("Run Comparative Report", null, {
            'Text1': this.userService.userFirstName + ' Applied Run Comparative Report',
            'Text2': 'User Filter Parameters: ' + JSON.stringify(this.TempFilterData)
          });
          this.compReviewServiceService.confirmationService.confirm({
            message: 'Are you sure, you want to generate report?',
            header: 'Confirmation',
            acceptLabel: 'Yes',
            acceptIcon:'pi pi-check',
            defaultFocus: 'reject',
            rejectLabel: 'No',
            rejectIcon:'pi pi-times',
            acceptButtonStyleClass: "confirm-dialog-button",
            rejectButtonStyleClass: "confirm-dialog-button",
      
            accept: () => {
              this.compReviewServiceService.isRunCompReport = true;
              this.messageService.add({ severity: 'success', summary: 'Run Comparative Report', detail: 'Generation Started' });
              this.compReviewServiceService.runComparativeReport()
              .subscribe({
                        next: (Element: any) => {
                          this.compReviewServiceService.isRunCompReport = false;  
                          this.messageService.add({ severity: 'success', summary: 'Run Comparative Report', detail: "Report Generated" });
                          this.FilterEvent.emit(this.FilterData);
                        }, error: (err: HttpErrorResponse) => {
                          this.compReviewServiceService.isRunCompReport = false;
                          if (err.status === 504) {
                            this.messageService.add({ severity: 'info', summary: 'Run Comparative Report', detail: this.compReviewServiceService.reportGenerationTimeMsg });
                            this.sampleMessageBox(this.compReviewServiceService.reportGenerationTimeMsg,true);
                          }else{
                            this.messageService.add({ severity: 'error', summary: 'Run Comparative Report', detail: 'Error Occurred' });
                          }
                        }
                      });
                    }
                  });
  }

generateCustomSampleRecords() {
    let sampleIndex = this.TempFilterData.findIndex((filterElem: { columnname: string; }) => filterElem.columnname === 'sampleName');
    this.TempFilterData[sampleIndex]["values"] = this.compReviewServiceService.customSampleName;
    let remark = ' Applied Add Custom Sample: ';
    if(this.isSaveFilter){
      remark = ' Applied Add And Saved Custom Sample: ';
    }
    this.userService.logUserActivity("Add Custom Sample", null, {
        'Text1': this.userService.userFirstName + remark +this.compReviewServiceService.customSampleName,
        'Text2': 'User Filter Parameters: ' + JSON.stringify(this.TempFilterData)
    });
    if(this.compReviewServiceService.customSampleName==""){
      this.messageService.add({ severity: 'warn', summary: 'Sample Generation', detail: 'Please add more details for custom sample records' });
      return
    }
    this.compReviewServiceService.confirmationService.confirm({
      message: 'Add Custom Samples for given sample name : ' + this.compReviewServiceService.customSampleName + ' ?',
      header: 'Confirmation',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      defaultFocus: 'reject',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass: "confirm-dialog-button",
      rejectButtonStyleClass: "confirm-dialog-button",

      accept: () => {
        this.compReviewServiceService.isLoadingGenerateCustomSample = true;
        this.messageService.add({ severity: 'success', summary: 'Sample Generation', detail: 'Generation Started' });
          this.compReviewServiceService.generateCustomSampleRecords(this.TempFilterData)
          .subscribe({
            next: (Element: any) => {
              this.FilterData[0]["values"] = this.compReviewServiceService.SampleFilterArray[0]["values"];
              this.displayFilter=false;
              this.compReviewServiceService.isLoadingGenerateCustomSample = false;
              let dataset: any = Element;
              let status = dataset["status"];
              let msg = dataset["msg"];
              if (status == "success") {
                this.sampleMessageBox(this.compReviewServiceService.sampleRecordsFoundMsg,true);
                this.messageService.add({ severity: 'success', summary: 'Sample Generation', detail: this.compReviewServiceService.sampleRecordsFoundMsg  });
              } else {
                this.sampleMessageBox(this.compReviewServiceService.sampleRecordsNotFoundMsg,false);
                this.messageService.add({ severity: 'warn', summary: 'Sample Generation', detail: this.compReviewServiceService.sampleRecordsNotFoundMsg  });
              }
              if(this.isSaveFilter) {
                  this.savedFilterQuaryName = this.compReviewServiceService.customSampleName;
                  this.addApplicationFilterQuery();
              }
              this.FilterEvent.emit(this.FilterData);
              this.closeFilterDialog();
              this.resetSample();
            }, error: (err: HttpErrorResponse) => {
              this.closeFilterDialog();
              this.resetSample();
              this.compReviewServiceService.isLoadingGenerateCustomSample = false;
              if (err.status === 504) {
                this.messageService.add({ severity: 'info', summary: 'Sample Generation', detail: this.compReviewServiceService.reportGenerationTimeMsg  });
                this.sampleMessageBox(this.compReviewServiceService.reportGenerationTimeMsg,true);
              }else{
                this.messageService.add({ severity: 'error', summary: 'Sample Generation', detail: 'Error Occurred' });
              }
            }
          });
      },
      reject: () => {
      this.closeFilterDialog();
      this.resetSample();
      } 
    });
  }

  generateRandomSampleRecords() {
      this.userService.logUserActivity("Add Random Sample", null, {
        'Text1': this.userService.userFirstName + ' Applied Add Random Sample',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(this.TempFilterData)
      });
    this.compReviewServiceService.isGenerateCustomSample = false;
    this.compReviewServiceService.confirmationService.confirm({
      message: 'Are you sure, you want to generate random sample records?',
      header: 'Confirmation',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      defaultFocus: 'reject',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass: "confirm-dialog-button",
      rejectButtonStyleClass: "confirm-dialog-button",

      accept: () => {
        this.compReviewServiceService.isLoadingGeneraterandomSample = true;
        this.messageService.add({ severity: 'success', summary: 'Sample Generation', detail: 'Generation Started' });
        this.compReviewServiceService.generateRandomSampleRecords()
        .subscribe({
            next: (Element: any) => {
              this.closeFilterDialog();
              this.resetSample();
              this.displayFilter=false;
              this.compReviewServiceService.isLoadingGeneraterandomSample = false;
              let dataset: any = Element;
              let status = dataset["status"];
              let msg = dataset["msg"];
              if (status == "success") {
                this.sampleMessageBox(this.compReviewServiceService.sampleRecordsFoundMsg,true);
                this.messageService.add({ severity: 'success', summary: 'Sample Generation', detail: this.compReviewServiceService.sampleRecordsFoundMsg  });
                this.FilterEvent.emit(this.FilterData);
              } else {
                this.messageService.add({ severity: 'warn', summary: 'Sample Generation', detail: this.compReviewServiceService.sampleRecordsNotFoundMsg  });
                this.FilterEvent.emit(this.FilterData);
              }
            }, error: (err: HttpErrorResponse) => {
              this.closeFilterDialog();
              this.resetSample();
              this.compReviewServiceService.isLoadingGeneraterandomSample = false;
              if (err.status === 504) {
                this.messageService.add({ severity: 'info', summary: 'Sample Generation', detail: this.compReviewServiceService.reportGenerationTimeMsg });
                this.sampleMessageBox(this.compReviewServiceService.reportGenerationTimeMsg,true);
              }else{
                this.messageService.add({ severity: 'error', summary: 'Sample Generation', detail: 'Error Occurred' });
              }
            }
          });
      },
      reject: () => {
      this.closeFilterDialog();
      this.resetSample();
      } 
    });
  }

  addInquiryDetail(isAddInquiryWithResult: boolean) {
    let transactionDateIndex = this.TempFilterData.findIndex((filterElem: { columnname: string; }) => filterElem.columnname === 'eventTimestamp');
    let transactionDates = this.TempFilterData[transactionDateIndex]["values"];
    /* If User chose a single Date then set auto value for another Date Range Value */
    if(Array.isArray(transactionDates) && !this.TempFilterData[transactionDateIndex]["values"][1]) {
      this.TempFilterData[transactionDateIndex]["values"][1] = this.TempFilterData[transactionDateIndex]["values"][0];
    }

    let InquiryTagIndex = this.TempFilterData.findIndex((filterElem: { columnname: string; }) => filterElem.columnname === 'tag');
    let inquiryTag = this.TempFilterData[InquiryTagIndex]["values"];

    let InquiryDateIndex = this.TempFilterData.findIndex((filterElem: { columnname: string; }) => filterElem.columnname === 'inquiryDate');
    let InquiryDate = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(this.TempFilterData[InquiryDateIndex]["values"])));

    if(transactionDates.length===0 || inquiryTag.length===0) {
      this.messageService.add({ severity: this.ConstantService.MESSAGE_SEVERITY_WARN, summary: this.ConstantService.MESSAGE_SUMMARY_WARN, detail: 'Please fill mandatory field details for adding Inquiry' });
      return;
    }
    this.userService.logUserActivity((this.isOpenFilterDialog ? "Edit Inquiry" : "Add Inquiry"), null, {
      'Text1': this.userService.userFirstName + (this.isOpenFilterDialog ? ' Applied Edit Inquiry: ' : ' Applied Add Inquiry: ') + inquiryTag,
      'Text2': 'User Filter Parameters: ' + JSON.stringify(this.TempFilterData)
    });

    /* Check Inquiry Executable Status */
      let confirmationMsg = "Want to" + (this.isOpenFilterDialog ? " Edit " : " Add ") + inquiryTag + " ?";
      this.FinraInquiryServiceService.isLoadingAddingFinraInquiry = true;

      if(isAddInquiryWithResult) {
        this.FinraInquiryServiceService.getInqiryExecutableStatus()
          .subscribe({
            next: (fetchResultExecutableElement: any) => {
              this.FinraInquiryServiceService.isLoadingAddingFinraInquiry = false;
              let fetchResultExecutableDataset: any = fetchResultExecutableElement;
              let fetchResultExecutableStatus = fetchResultExecutableDataset["status"];

              if(isAddInquiryWithResult && !fetchResultExecutableStatus) {
                confirmationMsg = "Want to Save Inquiry " + inquiryTag + " ?\n Fetching Result will be allowed for Regular Days in working hours (from 6 AM - 5 PM). Fetch results during regular business hours";
              }

              this.FinraInquiryServiceService.confirmationService.confirm({
                message: confirmationMsg,
                header: 'Confirmation',
                acceptLabel: 'Yes',
                acceptIcon:'pi pi-check',
                defaultFocus: 'reject',
                rejectLabel: 'No',
                rejectIcon:'pi pi-times',
                acceptButtonStyleClass: "confirm-dialog-button",
                rejectButtonStyleClass: "confirm-dialog-button",

                accept: () => {
                  this.FinraInquiryServiceService.isLoadingAddingFinraInquiry = true;
                  this.messageService.add({ severity: this.ConstantService.MESSAGE_SEVERITY_SUCCESS, summary: this.ConstantService.MESSAGE_SUMMARY_SUCCESS, detail: (this.isOpenFilterDialog ? 'Edit Inquiry Started' : 'Add Inquiry Started') });
                    this.FinraInquiryServiceService.addInquiry(this.TempFilterData)
                    .subscribe({
                      next: (Element: any) => {
                        this.displayFilter = false;
                        this.FinraInquiryServiceService.isLoadingAddingFinraInquiry = false;
                        let dataset: any = Element;
                        let status = dataset["status"];
                        let inquiryId = dataset["inquiryId"];
                        if (status === true) {
                          /* Fetching Inquiry Result */
                            if(isAddInquiryWithResult && fetchResultExecutableStatus) {
                              // Add User Action Log Entry for Saving Inquiry With Fetching Result
                              this.userService.logUserActivity('Save Inquiry', 'Add Inquiry', {
                                'Text1': 'Saved Inquiry (' + inquiryTag + ') Successfully with Fetching Inquiry Result',
                                'Text2': ''
                              });
                              this.FinraInquiryServiceService.fetchInquiryResult(inquiryId);
                            } else if(isAddInquiryWithResult && !fetchResultExecutableStatus) {
                              this.messageService.add({ severity: this.ConstantService.MESSAGE_SEVERITY_WARN, summary: this.ConstantService.MESSAGE_SUMMARY_WARN, detail: (this.isOpenFilterDialog ? ' Edited ' : ' Added ') + 'Inquiry without Fetching Result in non-working hours' });
                              this.userService.logUserActivity((this.isOpenFilterDialog ? "Edit Inquiry" : "Add Inquiry"), null, {
                                'Text1': this.userService.userFirstName + ' saved Inquiry without Feching Result for' + (this.isOpenFilterDialog ? ' Edited Inquiry: ' : ' Added Inquiry: ') + inquiryTag + ' in non-working hours',
                                'Text2': ''
                              });
                            }
                          /* End of Fetching Inquiry Result */
                          this.closeFilterDialog();
                          this.messageService.add({ severity: this.ConstantService.MESSAGE_SEVERITY_SUCCESS, summary: this.ConstantService.MESSAGE_SUMMARY_SUCCESS, detail: dataset["message"] });
                          this.FilterEvent.emit({"Action": "AddedInquiry", "updatedInquiryDate": InquiryDate});
                        } else {
                          this.messageService.add({ severity: this.ConstantService.MESSAGE_SEVERITY_ERROR, summary: this.ConstantService.MESSAGE_SUMMARY_ERROR, detail: dataset["message"] });
                          this.closeFilterDialog();
                        }
                      }, error: (err: HttpErrorResponse) => {
                        this.closeFilterDialog();
                        this.FinraInquiryServiceService.isLoadingAddingFinraInquiry = false;
                        this.messageService.add({ severity: this.ConstantService.MESSAGE_SEVERITY_ERROR, summary: this.ConstantService.MESSAGE_SUMMARY_ERROR, detail: 'Error Occurred' });
                      }
                    });
                },
                reject: () => {
                  this.FinraInquiryServiceService.isLoadingAddingFinraInquiry = false;
                } 
              });
            }, error: (err: HttpErrorResponse) => {
              this.FinraInquiryServiceService.isLoadingAddingFinraInquiry = false;
            }
          });
      } else {
        this.FinraInquiryServiceService.confirmationService.confirm({
          message: confirmationMsg,
          header: 'Confirmation',
          acceptLabel: 'Yes',
          acceptIcon:'pi pi-check',
          defaultFocus: 'reject',
          rejectLabel: 'No',
          rejectIcon:'pi pi-times',
          acceptButtonStyleClass: "confirm-dialog-button",
          rejectButtonStyleClass: "confirm-dialog-button",

          accept: () => {
            this.FinraInquiryServiceService.isLoadingAddingFinraInquiry = true;
            this.messageService.add({ severity: this.ConstantService.MESSAGE_SEVERITY_SUCCESS, summary: this.ConstantService.MESSAGE_SUMMARY_SUCCESS, detail: (this.isOpenFilterDialog ? 'Edit Inquiry Started' : 'Add Inquiry Started') });
              this.FinraInquiryServiceService.addInquiry(this.TempFilterData)
              .subscribe({
                next: (Element: any) => {
                  this.displayFilter = false;
                  this.FinraInquiryServiceService.isLoadingAddingFinraInquiry = false;
                  let dataset: any = Element;
                  let status = dataset["status"];
                  let inquiryId = dataset["inquiryId"];
                  if (status === true) {
                    // Add User Action Log Entry for Saving Inquiry Without Fetching Result
                    this.userService.logUserActivity('Save Inquiry', 'Add Inquiry', {
                      'Text1': 'Saved Inquiry (' + inquiryTag + ') Successfully without Fetching Inquiry Result',
                      'Text2': 'Completed Saving Inquiry without Fetching Inquiry Result'
                    });

                    this.closeFilterDialog();
                    this.messageService.add({ severity: this.ConstantService.MESSAGE_SEVERITY_SUCCESS, summary: this.ConstantService.MESSAGE_SUMMARY_SUCCESS, detail: dataset["message"] });
                    this.FilterEvent.emit({"Action": "AddedInquiry", "updatedInquiryDate": InquiryDate});
                  } else {
                    this.messageService.add({ severity: this.ConstantService.MESSAGE_SEVERITY_ERROR, summary: this.ConstantService.MESSAGE_SUMMARY_ERROR, detail: dataset["message"] });
                    this.closeFilterDialog();
                  }
                }, error: (err: HttpErrorResponse) => {
                  this.closeFilterDialog();
                  this.FinraInquiryServiceService.isLoadingAddingFinraInquiry = false;
                  this.messageService.add({ severity: this.ConstantService.MESSAGE_SEVERITY_ERROR, summary: this.ConstantService.MESSAGE_SUMMARY_ERROR, detail: 'Error Occurred' });
                }
              });
          },
          reject: () => {
            this.FinraInquiryServiceService.isLoadingAddingFinraInquiry = false;
          } 
        });
      }
    /* End of Check Inquiry Executable Status */

  }

  setFilterDropdown() {
    let column: any = this.GridColumns;
    if (column != null || column != undefined) {
      /*** set filter dropdown name**/
      let excludeFilter: string[] = this.gridService.getExcludeFilter(this.DefaultFilterArray);
      this.filterCols = this.gridService.getGridColumnsWithExclude(column, excludeFilter);
    }
  }

  ngOnInit() {
    this.TimeDropDown = Timecombo;
    this.FilterAccessibleApplications = this.ConstantService.SaveFilterQueryAccessibleApplications;
    this.setFilterDropdown();
    this.ApliedFilterName = [];

    this.filterByString = this.ConstantService.filterByString;
    this.filterByInt = this.ConstantService.filterByInt;
    this.filterByBoolean = this.ConstantService.filterByBoolean;

    this.defaultFilter();
    this.filterLabels();
    this.DefaultFixedFilterArray=[];
    if (this.DefaultFilterArray)
      for (let i = 0; i < this.DefaultFilterArray.length; i++)
        this.DefaultFixedFilterArray.push(this.DefaultFilterArray[i]);
  }

  getToolTipValue(filterRow:any) {
    if (filterRow.datatype == "DateRange") {
      var temp: any = this.datePipe.transform(filterRow.values[0], "yyyy-MM-dd");
      let dates = [];
      dates.push(temp);
      temp = this.datePipe.transform(filterRow.values[1], "yyyy-MM-dd");
      dates.push(temp);
      return dates;
    } else if (filterRow.datatype == "DateTime") {
      temp = this.datePipe.transform(filterRow.values, "yyyy-MM-dd");
      return temp;
    }
    else if (filterRow.datatype == "Date") {
      temp = this.datePipe.transform(filterRow.values, "yyyy-MM-dd");
      return temp;
    }
    return filterRow.values;
  }
  FormateDate(filterData:any,index: any, datatype: any) {
      filterData.values = [filterData.dateFilterValue,filterData.dateFilterValue];
  }
  changeFilterDataType(filterData:any) {
    if (filterData.dateFilterBy === 'Report Date') {
      filterData.datatype = 'clientDataSingleDate';
      if(typeof(filterData.values[0]) === 'object') {
        filterData.dateFilterValue = filterData.values[0];
      } else {
        filterData.dateFilterValue = this.userService.getFormatedDate(filterData.values[0]); 
      }
    } else if ((filterData.dateFilterBy != undefined && filterData.dateFilterBy.endsWith(' Date')) || filterData.datatype === 'DateRange' || !filterData.datatype) {
      filterData.datatype = 'DateRange';
      if(typeof(filterData.values[0]) !== 'object' && filterData.values !== "" && filterData.values !== null) {
        filterData.values[0] = this.userService.getFormatedDate(filterData.values[0]);
        filterData.values[1] = this.userService.getFormatedDate(filterData.values[1]);
      }
    } else if (filterData.datatype === 'Date' || !filterData.datatype) {
        filterData.values = this.userService.getFormatedDate(filterData.values);
    }
  }

  getFilterDataType(data:any, rowIndex:any) {
    let index = 0;
    for(let j=0;j<this.TempFilterData.length;j++){ 
      for(let i=0; i<this.filterCols.length;i++){
      if(this.TempFilterData[j].columnname==this.filterCols[i].value){
        index =i;
        break;
      }
      }      
    }
    data = this.filterCols[index];    
    this.TempFilterData[rowIndex].datatype = data.datatype;
    this.TempFilterData[rowIndex].label = data.label;
    let datatype: any = data.datatype;
    datatype = (data.datatype).toLocaleLowerCase();
    this.TempFilterData[rowIndex].label = data.label;
    this.TempFilterData[rowIndex].dropdown = data.dropdown;
    this.TempFilterData[rowIndex].dropdownvalue = data.dropdownvalue;
    if (datatype == "daterange") {
      this.TempFilterData[rowIndex].values = ["select date range"];
    } else if (datatype == "int" || datatype == "float" || datatype == "time" || datatype == "datetime"  || datatype == "boolean") {
      this.TempFilterData[rowIndex].filterby = '=';
      this.TempFilterData[rowIndex].values = '';
    } else if (datatype == "string" || datatype == "char") {
      this.TempFilterData[rowIndex].filterby = 'IS';
      this.TempFilterData[rowIndex].values = '';
    } else if (datatype == "array") {
      this.TempFilterData[rowIndex].values = [];
    }
    else {
      this.TempFilterData[rowIndex].filterby = 'Select Filter';
      this.TempFilterData[rowIndex].values = '';
    }
    this.TempFilterData[rowIndex].time = '';
  }

  showFilter() {
    if(["Reg-Inquiry-List"].includes(this.pageName)) {
      this.FetchUpdatedDefaultFilters.emit("Default-Filter-Dialog");
    }
    this.TempFilterData = this.TempFilterData.filter(value => JSON.stringify(value) !== '{}' && JSON.stringify(value) !== undefined);
    this.displayFilter = true;
  }

  defaultFilter() {
    /*** Get Last CAT Execution date*/
    this.TempFilterData = this.DefaultFilterArray;
  }

  addFilterRow() {
    this.TempFilterData.push(this.gridService.addFilterRow());
  }

  resetFilter() {
    this.TempFilterData = [];
    if (this.DefaultFilterArray) {
      for (let i = 0; i < this.DefaultFilterArray.length; i++)
        this.TempFilterData.push(this.DefaultFixedFilterArray[i]);
      this.filterLabels();
    }
  }

  filterLabels() {
    this.ApliedFilterName = [];
    this.FilterData = [];
    let j = 0;
    if (this.TempFilterData) {
      for (let i = 0; i < Object.keys(this.TempFilterData).length; i++) {
        this.FilterData[i] = this.TempFilterData[i];
        if ((this.FilterData[i] && Object.keys(this.ActiveApplicationFilter).length === 0 && this.isSaveFilter===false) || (Object.keys(this.ActiveApplicationFilter).length === 0 && this.isSaveFilter===true && this.FilterData[i] && ['Date', 'type'].indexOf(this.FilterData[i].label) !== -1) || (Object.keys(this.ActiveApplicationFilter).length > 0 && this.FilterData[i] && ['Date', 'type'].indexOf(this.FilterData[i].label) !== -1)) {
          if (this.FilterData[i].values != "" && this.FilterData[i].values != "Enter Value" &&
            this.FilterData[i].filterby != "Select Filter" && this.FilterData[i].values != null) {
            this.ApliedFilterName[j++] = this.FilterData[i];
          }
          if (this.FilterData[i].values === null) {
            this.FilterData[i].values = "";
          }
        }
      }
    }
  }
  selectBackDate(date: string | number | Date) {
    let tomorrow = new Date(date);
    this.TempFilterData[0].values[0] = this.userService.getyyyyMMddDateFormate(tomorrow.setDate(tomorrow.getDate() - 1));
    this.TempFilterData[0].values[1] = this.TempFilterData[0].values[0];
    if(this.TempFilterData[0].datatype === 'clientDataSingleDate'){
    let yesterday = new Date(new Date(date).setDate(new Date(date).getDate()-1));
    this.TempFilterData[0].values[0] = this.userService.getUTCDate_yyyyMMdd(yesterday);
    this.TempFilterData[0].values[1] = this.userService.getUTCDate_yyyyMMdd(yesterday);
    this.TempFilterData[0].values[1] = this.TempFilterData[0].values[0];
    this.compReviewServiceService.LastExecutionCompDate=[this.TempFilterData[0].values[0],this.TempFilterData[0].values[0]];
   }
    this.applyFilter(false);
  }
  selectNextDate(date: string | number | Date) {
    let tomorrow = new Date(date);
    this.TempFilterData[0].values[0] = this.userService.getyyyyMMddDateFormate(tomorrow.setDate(tomorrow.getDate() + 1));
    this.TempFilterData[0].values[1] = this.TempFilterData[0].values[0];
    if(this.TempFilterData[0].datatype === 'clientDataSingleDate'){
    let tomorrow =  new Date(new Date(date).setDate(new Date(date).getDate()+1));
    this.TempFilterData[0].values[0] = this.userService.getUTCDate_yyyyMMdd(tomorrow)
    this.TempFilterData[0].values[1] = this.userService.getUTCDate_yyyyMMdd(tomorrow);
    this.TempFilterData[0].values[0] = this.TempFilterData[0].values[1];
    this.compReviewServiceService.LastExecutionCompDate=[this.TempFilterData[0].values[0],this.TempFilterData[0].values[0]];
    }
    this.applyFilter(false);
  }

  applyFilter(isCustomFilter?: boolean) {
    if(this.isAddSamples){
      return;
    }
    if(this.FilterAccessibleApplications.includes(this.pageName) && isCustomFilter!==false && this.isSaveFilter===true && (!this.savedFilterQuaryName || this.savedFilterQuaryName.trim().length===0)) {
      this.messageService.add({ severity: 'warn', summary: 'Info Message', detail: 'Please enter Filter Query Name' });
      return;
    }
    this.filterLabels();
    /***check date range is not empty*/
    for (let i = 0; i < Object.keys(this.FilterData).length; i++) {
      this.FilterData[i].datatype = this.FilterData[i].datatype === 'clientDataSingleDate' ? 'DateRange' : this.FilterData[i].datatype;
      if (this.FilterData[i].values == "" && this.FilterData[i].values == "select date range" && this.FilterData[i].values == null) {
        alert("Please Select Date Range");
        this.showFilter();
        break;
      }
      if (this.FilterData[i].datatype === 'DateRange' && this.FilterData[i].values.length>0) {
        this.FilterData[i].values[0] = this.userService.getyyyyMMddDateFormate(this.DefaultFilterArray[i].values[0]);
        if (this.DefaultFilterArray[i].values[1]) {
          this.FilterData[i].values[1] = this.userService.getyyyyMMddDateFormate(this.DefaultFilterArray[i].values[1]);
        } else {
          this.FilterData[i].values[1] = this.FilterData[i].values[0];
          this.DefaultFilterArray[i].values[1] = this.DefaultFilterArray[i].values[0];
        }
      } else if (this.FilterData[i].datatype === 'Date') {
        this.FilterData[i].values = this.userService.getyyyyMMddDateFormate(this.FilterData[i].values);
      } else if(this.FilterData[i].datatype === 'clientDataSingleDate') {
        this.FilterData[i].values = this.userService.getyyyyMMddDateFormate(this.DefaultFilterArray[i].values);
      }
    }
    this.displayFilter = false;

    if(!isCustomFilter) {
      this.FilterEventClearEventType.emit(true);
    }

    /* Reset Active Application Filter when Don't want to save Filter Queries */
    (this.FilterAccessibleApplications.includes(this.pageName) && isCustomFilter!==false && this.isSaveFilter===false) && this.clearApplicationFilter.emit(this.FilterData);

    if(this.FilterAccessibleApplications.includes(this.pageName) && isCustomFilter!==false && this.isSaveFilter===true) {
      this.addApplicationFilterQuery();
    } else {
      /* Catch User Action Log */
        if(!["User Action Log"].includes(this.ConstantService.getApplicationName())) {
          this.userService.logUserActivity("User Applied Filter", this.ConstantService.getApplicationName(), {
            'Text1': this.userService.userFirstName + ' Applied Filter in ' + this.ConstantService.getApplicationName(),
            'Text2': 'User Filter Parameters: ' + JSON.stringify(this.FilterData.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        }
      this.FilterEvent.emit(this.FilterData);
    }

  }

  addApplicationFilterQuery() {
    let filterQuery:any = this.FilterData.filter((res:any) => res.label != 'Date');
    if(this.isAddSamples){
      filterQuery = this.TempFilterData.filter((res:any) => res.columnname != 'reportDate');
    }
    let payload = {
      mpid: this.userService.getActiveMPID(),
      application: this.pageName,
      filterQueryName: this.savedFilterQuaryName.trim(),
      FilterQuery: filterQuery,
      usedBy: this.userService.getUserName(),
      activeApplicationId: (Object.keys(this.ActiveApplicationFilter).length > 0 ? this.ActiveApplicationFilter.id : 0)
    }

    this.messageService.add({severity: 'info', summary: 'Generating Application Filter', detail: 'Please wait while searching & applying Application Filter..'});
    this.sharedHttpClientService.post(this.urlService.setAPIURl(APIURL.StoreApplicationFilterQuery), payload)
    .subscribe(
      {
        next: (response:any) => {
          let resultData: any = response;
          if(resultData.status) {
            this.messageService.add({ severity: 'success', summary: 'Info Message', detail: resultData.message });
            this.userService.logUserActivity('Generate Filter Query', null, {
              'Text1': resultData.message + ' | ' + 'User ' + this.userService.getUserName() + ' saved filter query by Name: ' + this.savedFilterQuaryName.trim(),
              'Text2': 'User Opted Filter Query Parameters: ' + JSON.stringify(this.FilterData.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
            });
          } else {
            this.messageService.add({ severity: 'warn', summary: 'Info Message', detail: resultData.message });
            this.userService.logUserActivity('Generate Filter Query', null, {
              'Text1': resultData.message + ' | ' + 'User ' + this.userService.getUserName() + ' saved filter query by Name: ' + this.savedFilterQuaryName.trim(),
              'Text2': 'User Opted Filter Query Parameters: ' + JSON.stringify(this.FilterData.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
            });
          }
          if(!this.isAddFilter){
          this.RetrieveApplicationFilters.emit(this.savedFilterQuaryName.trim());
          }
          if(this.isAddFilter){
            this.FilterEvent.emit(this.FilterData);
          }
        },    
        error: (err: HttpErrorResponse) => { },        
      }
    );
  }

  removeFilterTemp(index:any) {
    let symbol: string = this.TempFilterData[index].label;
    if (symbol.toLocaleLowerCase() == 'symbol') {
      //this.FilterEventClearSymbol.emit(true);
    }
    this.TempFilterData.splice(index, 1);
  }

  removeFilterLabel(index:any, data: { label: string; datatype: string; values: any; }) {
    /***Find index in json by labal name */
    let index2 = this.FilterData.findIndex(function (item: { label: string; }, i: any) {
      return item.label === data.label;
    });
    let label: string = data.label;
    let datatype: string = data.datatype;

    /* Catch User Action Log */
      let filerType = label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
      this.userService.logUserActivity("User cancelled " + filerType + " from applied Filters", null, {
        'Text1': this.userService.userFirstName + ' cancelled ' + filerType + ' from applied Filters',
        'Text2': 'User cancelled for - ' + filerType + ': ' + data.values
      });

    if (label.toLocaleLowerCase() == 'symbol') {
      this.FilterEventClearSymbol.emit(true);
    }
    if (label.toLocaleLowerCase() == 'code' || label.toLocaleLowerCase() == 'failure code') {
      this.FilterEventClearCode.emit(true);
    }
    if (label.toLocaleLowerCase() == 'error code') {
      this.FilterEventClearCode.emit(true);
    }
    if (label.toLocaleLowerCase() == 'code') {
      this.FilterEventClearCode.emit(true);
    }
    if (label.toLocaleLowerCase() == 'groupname' || label.toLocaleLowerCase() == 'group name') {
      this.FilterEventClearGroupName.emit(true);
    }

    if (label.toLocaleLowerCase() == 'samplename' || label.toLocaleLowerCase() == 'sample name') {
      this.FilterEventClearSampleName.emit(true);
    }

    if(label.toLocaleLowerCase() == 'representativeind'){
      this.FilterEventClearRepresentativeOrder.emit(true)
    }
    if (datatype.toLocaleLowerCase() == "array") {
      this.TempFilterData[index2].values = [];
    }
     else {
      this.TempFilterData[index2].values = "";
    }
    this.applyFilter(false);
  }

  removeApplicationFilter() {
    /* Catch User Action Log */
      this.userService.logUserActivity("Cancelled Application Filter", null, {
        'Text1': this.userService.userFirstName + ' cancelled Application Filter',
        'Text2': 'User cancelled Application Filter: ' + this.savedFilterQuaryName
      });
    this.isSaveFilter = false;
    this.savedFilterQuaryName = '';
    this.clearApplicationFilter.emit();
  }

  passIndexValue(index: any) {
    this.hoveredIndex = index;
  }

  // Adding Custom Filter Options in Filter By 
  // (Add `isNeededOwnFilterOptions` Property for adding Own FilterOptions for particular Field 
  // and Add `isNeededINClauseAtOptions` Property for adding IN/NOT-IN clause in existing FilterOptions for particular Field 
  // in GridColumns.json column field)
  applyCustomerFilterOptions(templateFilterOptions: any, filterRowObj: { isNeededINClauseAtOptions: any; }) {
    let updatedTemplateFilterOptions = [...templateFilterOptions];
    if(filterRowObj.isNeededINClauseAtOptions) {
      updatedTemplateFilterOptions = [...this.filterByInt, ...this.filterByString.filter((filterRowObj) => filterRowObj.label.includes("IN") && filterRowObj.value.includes("IN"))];
    }
    return updatedTemplateFilterOptions;
  }

  // Change Field Data type of Filter Text
  onChangeFieldDataType(fieldRowObj: { filterby: string; datatype: string; }) {
    if(this.filterByInt.filter((filterType) => filterType.label===fieldRowObj.filterby).length > 0) {
      fieldRowObj.datatype = "Int";
    } else if(this.filterByString.filter((filterType) => filterType.label===fieldRowObj.filterby).length > 0) {
      fieldRowObj.datatype = "string";
    }
  }
  close(){
    if(this.datePicker != undefined){
    this.datePicker.overlayVisible = false;
    }
  }
  getDateEmitter(isDateRange:any,filterdata?:any,index?:any){
    if(isDateRange){
      this.TempFilterData[index].values = this.datepickerService.dateRange;
    }
    else if (filterdata.datatype == 'clientDataSingleDate' ){
      this.FormateDate(filterdata?.values,index,filterdata?.datatype)
      this.TempFilterData[index].values = [this.datepickerService.reportDate,this.datepickerService.reportDate]
    }
    else{
      this.TempFilterData[index].values = this.datepickerService.reportDate;
    }
  }



  sampleMessageBox(message: any,status:any) {
    this.showMessage=true;
    this.showMessageDetails=message;
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }
}

